import WidgetTemplate from './WidgetTemplate'
import { mapGetters } from 'vuex'
import { formatDisplayNumber } from '@/utils/number'
import { formatDisplayDate2 } from '@/utils/date'
import { appID, appIDDesc } from '@/const/underwriting'
import differenceInMinutes from 'date-fns/differenceInMinutes'

export const widgetMixin = function (autoReload = false) {
  return {
    data() {
      return {
        firstAccessedTime: new Date(),
        timeNow: new Date(),
        appIds: [{
          id: 'all',
          description: 'All'
        }],
        appIdForm: {
          appId: 'all'
        },
        intervalReloadObj: null,
        intervalTimeNowObj: null,
        preventIdlePollingObj: null
      }
    },
    computed: {
      ...mapGetters([
        'checkAccess'
      ]),
      currPrefix() {
        return this.$store.state.agency.quotation.commonInfo.currPrefix
      },
      selectedAppId() {
        if (this.appIdForm.appId) {
          const result = this.appIds.find(x => x.id === this.appIdForm.appId)
          if (result) {
            return result
          }
        }
        return {}
      }
    },
    methods: {
      updateTimeNow() {
        this.timeNow = new Date()
      },
      formatDisplayNumber(xNum) {
        return formatDisplayNumber(xNum)
      },
      formatDisplayDate(xDate) {
        return formatDisplayDate2(xDate)
      },
      doSelectAppId(appId, reload = true) {
        this.appIdForm.appId = appId
        if (reload) {
          this.doReload()
        }
      },
      widgetTextStyle(text) {
        const convStr = text + ''
        if (convStr.length >= 8) {
          return 'widgetText small'
        }
        return 'widgetText'
      },
      formatPermitAppIdsText(appIds) {
        let result = ''
        if (appIds && appIds.length > 0) {
          appIds.forEach(appId => {
            result += appIDDesc[appId] + ', '
          })
          // Remove the last comma
          result = result.substr(0, result.length - 2)
        }
        return result
      },
      doReload() {
        // Component should override this method with its own reload
      },
      intervalReload() {
        this.intervalReloadObj = setInterval(() => {
          this.doReload()
        }, 60000)
      },
      intervalTimeNow() {
        this.intervalTimeNowObj = setInterval(() => {
          this.updateTimeNow()
        }, 60000)
      },
      preventIdlePolling() {
        // As interval Reload will prevent session from timeout,
        // We have this idle tracker
        // If user idles in dashboard for too long, it will cut off the polling time
        this.preventIdlePollingObj = setInterval(() => {
          if (differenceInMinutes(new Date(), this.firstAccessedTime) >= 10) {
            clearInterval(this.intervalReloadObj)
            clearInterval(this.preventIdlePollingObj)
          }
        }, 60000)
      }
    },
    components: {
      WidgetTemplate
    },
    created() {
      this.updateTimeNow()
      // Set interval to update "time now"
      // so that the display for timedistance will be updated
      this.intervalTimeNow()

      if (autoReload) {
        this.intervalReload()
        this.preventIdlePolling()
      }

      // Set AppIds based on privilege
      if (this.checkAccess(['cargoQuote', 'cargoQuoteQuery'])) {
        this.appIds.push({
          id: appID.CARGO,
          description: 'Cargo'
        })
      }
      if (this.checkAccess(['motorQuote', 'motorQuoteQuery'])) {
        this.appIds.push({
          id: appID.MOTOR,
          description: 'Motor'
        })
      }
      if (this.checkAccess(['travelQuote', 'travelQuoteQuery'])) {
        this.appIds.push({
          id: appID.TRAVEL,
          description: 'Travel'
        })
      }
      if (this.checkAccess(['fireQuote', 'fireQuoteQuery'])) {
        this.appIds.push({
          id: appID.FIRE,
          description: 'Fire'
        })
      }
      if (this.checkAccess(['maidQuote', 'maidQuoteQuery'])) {
        this.appIds.push({
          id: appID.MAID,
          description: 'Maid'
        })
      }
      if (this.checkAccess(['packageQuote', 'packageQuoteQuery'])) {
        this.appIds.push({
          id: appID.PACKAGE,
          description: 'Package'
        })
      }
      if (this.checkAccess(['paQuote', 'paQuoteQuery'])) {
        this.appIds.push({
          id: appID.PA,
          description: 'Personal Accident'
        })
      }
    },
    destroyed() {
      clearInterval(this.intervalTimeNowObj)

      if (autoReload) {
        clearInterval(this.intervalReloadObj)
        clearInterval(this.preventIdlePollingObj)
      }
    }
  }
}
